import angular from 'angular'

import { VD_CLASSES } from '../../constants'
import template from './vd-splash.html'

angular.module('vend.ui').directive('vdSplash', function () {
  return {
    scope: {
      templatePath: '=',
      dismissible: '=',
      templateData: '=',
      scrollable: '<',
    },
    restrict: 'E',
    template,
    link(scope, $element, attrs) {
      attrs.$addClass('vd-splash-fullscreen-container')
    },
    controller($document, vdSplashService) {
      /**
       * Closes and removes the splash from the dom. Makes this one method available in the template to close the
       * splash. Accessed via `vdSplashCtrl.close` in the template.
       *
       * @method close
       */
      this.close = vdSplashService.closeSplash

      // Add class to body that prevents scrolling when splash is open
      const bodyNode = $document.find('body')
      bodyNode.addClass(VD_CLASSES.noBodyScroll)
    },
    controllerAs: 'vdSplashCtrl',
    bindToController: true,
  }
})
